module.exports = __webpack_public_path__ + "img/plus-circle-red.486fd171.svg";